import React from 'react';
import { Crisp } from 'crisp-sdk-web';
import { useEffect } from 'react';
import {
  useAuthContext,
  configManager,
  api,
  generateUUID
} from 'react-structure-admin';
import useCookieHandler from 'core/useCookieHandler';

const CrispChat = ({ allowAnonymous = false }) => {
  const {
    company,
    user,
    subscription,
    isAuthenticated,
    isAdmin
  } = useAuthContext();
  const { cookies, setCookie } = useCookieHandler();

  const getTokenId = () => {
    if (!user || Object.keys(user).length === 0) {
      return;
    }

    const cookieKey = `crisp_token_${user.id}`;
    let token = cookies[cookieKey];

    if (!token) {
      token = btoa(generateUUID());
      setCookie(cookieKey, token);
    }

    return token;
  };

  const showChat = () => {
    try {
      Crisp.chat.show();
      configManager.setConfig({ allowChat: true });
    } catch (error) {
      console.log(error);
    }
  };

  const hideChat = () => {
    try {
      Crisp.chat.hide();
      configManager.setConfig({ allowChat: false });
    } catch (error) {
      console.log(error);
    }
  };

  const setAdminUserData = () => {
    try {
      Crisp.user.setNickname(user.name);
      Crisp.user.setEmail(user.email);

      if (user.profileImage) {
        Crisp.user.setAvatar(`${api.getBaseUrl()}/users/${user.id}/image`);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const setUserData = () => {
    if (!user) {
      return;
    }

    try {
      Crisp.user.setNickname(user.name);
      Crisp.user.setEmail(user.email);

      if (user.phoneNumber) {
        Crisp.user.setPhone(user.phoneNumber);
      }

      if (company && company.name) {
        Crisp.user.setCompany(company.name);
      }

      if (user.profileImage) {
        Crisp.user.setAvatar(`${api.getBaseUrl()}/users/${user.id}/image`);
      }

      Crisp.session.setData({ Plano: subscription?.planName });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      const handleCrisp = async () => {
        if (isAdmin()) {
          setAdminUserData();
          return;
        }

        if (isAuthenticated() || allowAnonymous) {
          Crisp.setTokenId();
          Crisp.session.reset();

          await new Promise((resolve) => setTimeout(resolve, 800));

          if (isAuthenticated()) {
            Crisp.setTokenId(getTokenId());
            Crisp.session.reset();
          }

          setUserData();
          showChat();
        } else {
          hideChat();
        }
      };

      handleCrisp();
    }, 2000);

    return () => clearTimeout(timeout);
  }, [isAuthenticated, company]);

  return <></>;
};

export default CrispChat;
